import { useState } from "react";

import Presentation from "./presentation";

const Component = ( {
	title, subtitle, content, primaryCtaText, secondaryCtaText, withCloseButton, opened, setOpened, ...rest
} ) => {
	// const [ opened, setOpened ] = useState ( true );

	function close () {
		setOpened ( false );
	}

	return (
		<Presentation
			close            = { close }
			content          = { content }
			opened           = { opened }
			primaryCtaText   = { primaryCtaText }
			secondaryCtaText = { secondaryCtaText }
			setOpened        = { setOpened }
			subtitle         = { subtitle }
			title            = { title }
			withCloseButton  = { withCloseButton }
			{ ...rest }
		/>
	);
};

export default Component;